import { Component } from 'react'
import { Reward } from 'interfaces/bounty'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/RewardDetails/StatusCopy.css'
import { RewardsStatusLabel } from 'components/features/pfm/RewardDetails/RewardsStatusLabel/RewardsStatusLabel'

type StatusCopyProps = {
  status: Reward['status']
  onClick?: () => void
}

const CLASS_NAME_FOR_STATUS: Partial<Record<Reward['status'], string>> = {
  confirmed: styles.confirmed,
  earned: styles.earned,
  expired: styles.expired,
  pending: styles.pending,
}

class StatusCopy extends Component<StatusCopyProps> {
  render () {
    const { status, onClick } = this.props
    const classNameForStatus: string | undefined = CLASS_NAME_FOR_STATUS[status]
    const className = cn(styles.statusCopy, classNameForStatus)

    return (
      <div className={ className } onClick={ onClick }>
        <RewardsStatusLabel status={ status } isColoured isCapitalized={ false } />
      </div>
    )
  }
}

export default StatusCopy
